import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from '@/routes/router';
import { ViteAppShell } from '@/vite/ViteAppShell';
import { ViteClientProviders } from '@/vite/ViteClientProviders';
import './styles/globals.css';

export function App() {
  return (
    <BrowserRouter>
      <ViteClientProviders>
        <ViteAppShell>
          <AppRoutes />
        </ViteAppShell>
      </ViteClientProviders>
    </BrowserRouter>
  );
}
